import { Tabs } from 'antd';
import React from 'react';
import { Container, StyledTabs } from "./styles"
import Geral from './components/geral';
import Movimentacoes from './components/movimentacoes';
import Estoque from './components/estoque';
import SolicRetorno from './components/solicitacaoRetorno';
import Entrega from './components/entrega';
import Coleta from './components/coleta';
import Tracking from './components/tracking';
import Atendimento from './components/atendimento';

const App: React.FC = () => (
  <Container>
    <StyledTabs defaultActiveKey="1" tabPosition='left'  >
      <Tabs.TabPane tab={<div className='tab'>Geral</div>} key="1" >
        <Geral />
      </Tabs.TabPane>
      <Tabs.TabPane tab={<div className='tab'>Movimentações</div>} key="2" >
        <Movimentacoes />
      </Tabs.TabPane>
      <Tabs.TabPane tab={<div className='tab'>Estoque</div>} key="3" >
        <Estoque />
      </Tabs.TabPane>
      <Tabs.TabPane tab={<div className='tab'>Solicitação de retorno</div>} key="4" >
        <SolicRetorno />
      </Tabs.TabPane>
      <Tabs.TabPane tab={<div className='tab'>Entregas no CD</div>} key="5" >
        <Entrega />
      </Tabs.TabPane>
      <Tabs.TabPane tab={<div className='tab'>Coletas no CD</div>} key="6" >
        <Coleta />
      </Tabs.TabPane>

      <Tabs.TabPane tab={<div className='tab'>Tracking</div>} key="7" >
        <Tracking />
      </Tabs.TabPane>

      <Tabs.TabPane tab={<div className='tab'>Atendimento</div>} key="8" >
        <Atendimento />
      </Tabs.TabPane>

    </StyledTabs>
  </Container>
);

export default App;
